<div
  class="search-dropdown"
  [ngClass]="{
    open: shown,
    small: size === 'small', 
    large: size === 'large',
    medium: size === 'medium',
    
  }"
>
  <div
    class="search-dropdown__btn"
    [ngClass]="{
      'disable-input': isDisabled
    }"
    (click)="show()"
  >
    <span>{{ _placeholder }}</span>
  </div>
  <div class="search-dropdown__dropdown">
    <input
      class="search-dropdown__dropdown__search"
      type="text"
      placeholder="Search"
      [(ngModel)]="keyword"
      (keyup)="search(keyword)"
      #input
      (blur)="onTouch()"
    />
    <div class="search-dropdown__dropdown__scroller">
      <div
        class="search-dropdown__dropdown__item"
        *ngFor="let item of list"
        (click)="select(item)"
      >
        {{ item[_label] }}
      </div>
      @if(list.length===0){
      <div class="search-dropdown__dropdox__msg">No Result Found</div>
      }
    </div>
  </div>
</div>
